// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__1gja9","time":"styles_time__3mbFc"};